var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-toolbar',{attrs:{"crumbs":_vm.crumbs}}),_c('div',{staticStyle:{"margin":"15px"}}),_c('v-row',[_c('router-link',{staticClass:"navigation",attrs:{"to":{ name: 'members-access' }}},[_vm._v(" Member Access Report ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }